





















import Component from "vue-class-component";
import MedicalInvoiceBase from "@/components/medicalEdit/invoice/MedicalInvoiceBase";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";
import TimePicker from "@/components/common/TimePicker.vue";
import PatientInfo from "@/components/medicalEdit/invoice/part/PatientInfo.vue";
import Burden from "@/components/medicalEdit/invoice/part/Burden.vue";
import InvoiceInsBurdens from "@/components/medicalEdit/invoice/part/InvoiceInsBurdens.vue";
import VisitDays from "@/components/medicalEdit/invoice/part/VisitDays.vue";
import InvoiceRange from "@/components/medicalEdit/invoice/part/InvoiceRange.vue";
import Remarks from "@/components/medicalEdit/invoice/part/Remarks.vue";
import Money from "@/components/medicalEdit/invoice/part/Money.vue";

@Component({
  components: {
    EditDayChangePicker,
    NumberInput,
    TimePicker,
    PatientInfo,
    Burden,
    InvoiceInsBurdens,
    VisitDays,
    InvoiceRange,
    Remarks,
    Money
  }
})
export default class MedicalInvoiceRev2 extends MedicalInvoiceBase {}
